import {
  createEntityAdapter,
  EntityAdapter,
  EntityState,
  Update,
} from '@ngrx/entity';
import {
  Action,
  createAction,
  createReducer,
  props,
  on,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import {
  IScenarioPreprogramme,
  ScenarioPreprogramme,
} from '../../_models/ScenarioPreprogramme';

export const name = 'scenarioPreprogrammes';

export interface ScenarioPreprogrammeState
  extends EntityState<IScenarioPreprogramme> {
  selectedId: number | null;
  isInitialized: boolean;
}

function selectScenarioPreprogramme(a: IScenarioPreprogramme): any {
  return a.id;
}

function sortByName(
  a: IScenarioPreprogramme,
  b: IScenarioPreprogramme
): number {
  if (a.nom < b.nom) {
    return -1;
  } else if (a.nom > b.nom) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<IScenarioPreprogramme> =
  createEntityAdapter<IScenarioPreprogramme>({
    selectId: selectScenarioPreprogramme,
    sortComparer: sortByName,
  });

const initialState: ScenarioPreprogrammeState = adapter.getInitialState({
  selectedId: null,
  isInitialized: false,
});

/* ACTION */
export const loadScenarioPreprogrammesAction = createAction(
  '[ScenarioPreprogramme] Load ScenarioPreprogrammes'
);
export const loadScenarioPreprogrammesSuccessAction = createAction(
  '[ScenarioPreprogramme] Load ScenarioPreprogrammes Success',
  props<{ payload: IScenarioPreprogramme[] }>()
);
export const deepLoadScenarioPreprogrammeAction = createAction(
  '[ScenarioPreprogramme] Deep Load ScenarioPreprogramme',
  props<{ id: number | string }>()
);
export const deepLoadScenarioPreprogrammeActionSuccessAction = createAction(
  '[ScenarioPreprogramme] Deep Load ScenarioPreprogramme Success',
  props<{ payload: Update<IScenarioPreprogramme> | undefined }>()
);
export const setScenarioPreprogrammesAction = createAction(
  '[ScenarioPreprogramme] Set ScenarioPreprogramme',
  props<{ payload: IScenarioPreprogramme[] }>()
);

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadScenarioPreprogrammesSuccessAction, (state, {payload}) => {
    return adapter.setAll(payload, {...state, isInitialized: true});
  }),
  on(deepLoadScenarioPreprogrammeActionSuccessAction, (state, {payload}) => {
    if (payload) {
      return adapter.updateOne(payload, {
        ...state,
        selectedId: payload.id as number,
      });
    } else {
      return state;
    }
  }),
  on(setScenarioPreprogrammesAction, (state, {payload}) => {
    return adapter.setAll(payload, state);
  }),
);

export function scenarioPreprogrammeReducer(
  state: ScenarioPreprogrammeState | undefined,
  action: Action
): ScenarioPreprogrammeState {
  return reducer(state, action);
}

/* SELECTOR */
const selectScenarioPreprogrammeState =
  createFeatureSelector<ScenarioPreprogrammeState>(name);

const isInitialized = (state: ScenarioPreprogrammeState) => state.isInitialized;
export const {selectIds, selectEntities, selectAll, selectTotal} =
  adapter.getSelectors();

export const selectAllScenarioPreprogrammes = createSelector(
  selectScenarioPreprogrammeState,
  (state) => {
    return state.ids.map(
      (id: any) => new ScenarioPreprogramme(state.entities[id])
    );
  }
);
export const selectIsScenarioPreprogrammeInitialized = createSelector(
  selectScenarioPreprogrammeState,
  isInitialized
);
export const selectedScenarioPreprogramme = createSelector(
  selectScenarioPreprogrammeState,
  (state) => {
    if (state.selectedId) {
      return new ScenarioPreprogramme(state.entities[state.selectedId]);
    }

    return undefined;
  }
);
